import { openPageModal } from '~/utils/mobileApp';

import { INITIAL_BUSINESS_PUBLIC_ID } from '../../mmp/constants';
import { ASSIGN_CASHNOTE_PLUS_URL } from '../constants';

// 캐시노트 플러스 멤버십 가입 안내 함수.
export const registerMembership = (
  businessId: string,
  queryString?: string,
) => {
  if (businessId === INITIAL_BUSINESS_PUBLIC_ID) return;

  void openPageModal(`${ASSIGN_CASHNOTE_PLUS_URL()}${queryString || ''}`);
};
